import { action, register, types } from "@gadgetinc/mobx-quick-tree";
import { apiKeyGenerator } from "./apiKeyGenerator";
import { GadgetDomainModelClass, contentHash } from "./utils";

@register
export class LegacyEnvironmentApiKey extends GadgetDomainModelClass("EnvironmentApiKey", {
  secretKey: types.optional(types.string, apiKeyGenerator),
}) {
  get contentHash() {
    return contentHash([this.secretKey]);
  }

  @action
  setSecretKey(key: string) {
    this.secretKey = key;
  }
}
